<template>
  <div>
    <div
      class="custom-loading"
      :class="isFullScreen ? 'custom-loading-component-full' : 'custom-loading-component'"
      :style="{ display: show ? 'block' : 'none' }"
    >
      <component v-if="parsNoTitleLogoComponent" :is="parsNoTitleLogoComponent" class="mt-10" />
      <div class="centered" v-else>
        <div class="blob-small-top"></div>
        <div class="blob-medium-top-left"></div>
        <div class="top-line"></div>
        <div class="blob-medium-top-right"></div>
        <div class="blob-1"></div>
        <div class="blob-line"></div>
        <div class="blob-middle-small"></div>
        <div class="blob-2"></div>
        <div class="blob-medium-bottom-left"></div>
        <div class="bottom-line"></div>
        <div class="blob-medium-bottom-right"></div>
        <div class="blob-small-bottom"></div>
        <div class="btn-div" v-if="showCancelButton">
          <v-icon class="cancel-btn" @click="cancelLoading"> mdi-close</v-icon>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import constant from "../main.constants";
import { loadComponent } from "@/helpers/separateLoaderEnvHelper";

export default {
  name: "custom-loading",
  props: {
    show: Boolean,
    showCancelButton: Boolean,
    isFullScreen: { type: Boolean, default: true }, //TODO: Partial olarak kullanılabilecek hale getirilmeli.
  },
  watch: {
    show(newValue) {
      if (newValue) {
        // setTimeout kullanılmamalı.
        //b-overlay kaldırıldığı için b-overlay'in show ve shown attributelarındaki delayi sağlamak için kullanıldı.
        this.shownEmitTimeout = setTimeout(() => {
          this.$emit("shown");
          this.shownEmitTimeout = null;
        });
      }
    },
  },
  data() {
    return {
      overlayClass: "",
      shownEmitTimeout: null,
      parsNoTitleLogoComponent: null,
    };
  },
  async created() {
    await this.loadParsNoTitleLogoComponent();
  },
  beforeDestroy() {
    this.clearShownTimeout();
  },
  methods: {
    async loadParsNoTitleLogoComponent() {
      try {
        const component = await loadComponent(constant.ENV_COMPONENTS.BOVERLAY_PARSNOTITLELOGO);
        if (component) {
          this.parsNoTitleLogoComponent = component.default || component;
        }
      } catch (error) {
        console.error("ParsNoTitleLogo component yüklenemedi:", error);
      }
    },
    clearShownTimeout() {
      if (this.shownEmitTimeout) {
        clearTimeout(this.shownEmitTimeout);
        this.shownEmitTimeout = null;
      }
    },
    cancelLoading() {
      this.$emit("cancelLoading");
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-loading-component-full {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.custom-loading-component {
  position: absolute;
  width: 100%;
  height: 100%;
}

.custom-loading {
  z-index: 2147483647;
  background-color: rgba(255, 255, 255, 0.812);
}

.centered {
  width: 400px;
  height: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.btn-div {
  margin-top: -220px;
  margin-left: 1090px;
}
.cancel-btn {
  color: white;
  background-color: #00a7e1 !important;
  border-radius: 100px;
}
.blob-small-top {
  width: 12.5px;
  height: 12.5px;
  position: absolute;
  background: #00a7e1;
  border-radius: 50%;
  top: 46%;
  left: 46%;
  transform: translate(-50%, -50%);
  animation: blur-anim 2.5s ease infinite;
}
.blob-small-bottom {
  width: 12.5px;
  height: 12.5px;
  position: absolute;
  background: #00a7e1;
  border-radius: 50%;
  top: 54%;
  left: 54%;
  transform: translate(-50%, -50%);
  animation: blur-anim 2.5s ease infinite;
}
.blob-medium-top-left {
  width: 15px;
  height: 15px;
  position: absolute;
  background: #00a7e1;
  border-radius: 50%;
  left: 46%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: blur-anim 2.5s ease infinite;
}
.blob-medium-top-right {
  width: 15px;
  height: 15px;
  position: absolute;
  background: #00a7e1;
  border-radius: 50%;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);
  animation: blur-anim 2.5s ease infinite;
}
.blob-medium-bottom-left {
  width: 15px;
  height: 15px;
  position: absolute;
  background: #00a7e1;
  border-radius: 50%;
  left: 50%;
  top: 54%;
  transform: translate(-50%, -50%);
  animation: blur-anim 2.5s ease infinite;
}
.blob-medium-bottom-right {
  width: 15px;
  height: 15px;
  position: absolute;
  background: #00a7e1;
  border-radius: 50%;
  left: 54%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: blur-anim 2.5s ease infinite;
}
.top-line {
  width: 3px;
  height: 15px;
  position: absolute;
  background: #00a7e1;
  left: 47.5%;
  top: 48.5%;
  transform: translate(-50%, -50%) rotate(45deg);
  animation: blur-anim 2.5s ease infinite;
}
.bottom-line {
  width: 3px;
  height: 15px;
  position: absolute;
  background: #00a7e1;
  left: 52.5%;
  top: 51.5%;
  transform: translate(-50%, -50%) rotate(45deg);
  animation: blur-anim 2.5s ease infinite;
}
.blob-1 {
  width: 20px;
  height: 20px;
  position: absolute;
  background: #00a7e1;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: osc-l 2.5s ease infinite;
}
.blob-2 {
  width: 20px;
  height: 20px;
  position: absolute;
  background: #00a7e1;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: osc-r 2.5s ease infinite;
}
.blob-line {
  border-radius: 12px;
  width: 3px;
  height: 40px;
  position: absolute;
  background: #00a7e1;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  animation: line-anim 2.5s ease infinite;
}
.blob-middle-small {
  width: 8px;
  height: 8px;
  position: absolute;
  background: #00a7e1;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: blur-anim 2.5s ease infinite;
}
@keyframes line-anim {
  0% {
    height: 40px;
  }
  50% {
    filter: blur(1px) contrast(3);
    height: 5px;
  }
  100% {
    height: 40px;
  }
}
@keyframes osc-l {
  0% {
    width: 20px;
    height: 20px;
    top: 55%;
    left: 45%;
  }
  50% {
    filter: blur(1px) contrast(3);
    width: 10px;
    height: 10px;
  }
  100% {
    width: 20px;
    height: 20px;
    top: 45%;
    left: 55%;
  }
}
@keyframes osc-r {
  0% {
    width: 20px;
    height: 20px;
    top: 45%;
    left: 55%;
  }
  50% {
    filter: blur(1px) contrast(3);
    width: 10px;
    height: 10px;
  }
  100% {
    width: 20px;
    height: 20px;
    top: 55%;
    left: 45%;
  }
}
@keyframes blur-anim {
  0% {
    filter: blur(0px);
  }
  50% {
    filter: blur(1px) contrast(3);
  }
  100% {
    filter: blur(0px);
  }
}
</style>
